/** Engineering engagement workflow for DEBSUN Technologies services. */

export const ENGINEERING_WORKFLOW = [
  {
    id: "consultation",
    step: 1,
    name: "Consultation",
    description:
      "Initial discussion to understand plant context, constraints and engineering objectives.",
  },
  {
    id: "requirement-analysis",
    step: 2,
    name: "Requirement Analysis",
    description:
      "Structured capture of functional, operational and compliance requirements.",
  },
  {
    id: "engineering-assessment",
    step: 3,
    name: "Engineering Assessment",
    description:
      "Technical evaluation of architecture options, interfaces and delivery risk.",
  },
  {
    id: "technical-proposal",
    step: 4,
    name: "Technical Proposal",
    description:
      "Clear engineering proposal covering scope, approach, deliverables and assumptions.",
  },
  {
    id: "quotation",
    step: 5,
    name: "Quotation",
    description:
      "Commercial quotation aligned to the agreed technical scope.",
  },
  {
    id: "implementation",
    step: 6,
    name: "Implementation",
    description:
      "Engineering execution — design, development, configuration and integration.",
  },
  {
    id: "commissioning",
    step: 7,
    name: "Commissioning",
    description:
      "Site commissioning, validation and handover against agreed acceptance criteria.",
  },
  {
    id: "support",
    step: 8,
    name: "Support",
    description:
      "Post-handover engineering support, optimisation and lifecycle assistance.",
  },
];

/**
 * Quotation pathways — kept deliberately separate.
 * Engineering services quote through DEBSUN.
 * EPC projects route to the strategic partner workflow.
 */
export const QUOTATION_WORKFLOWS = {
  engineeringServices: {
    id: "engineering-services",
    path: [
      "Engineering Services",
      "Website Quote",
      "DEBSUN Technologies",
    ],
  },
  epcProjects: {
    id: "epc-projects",
    path: [
      "EPC Projects",
      "Information",
      "Strategic Partner",
      "External Website",
      "Partner Workflow",
    ],
  },
};
